// What a stop asks the user to do before the tour will move on. Only stops the
// user can satisfy from the page itself carry one, and every one of them can be
// skipped, so nothing here can trap someone who does not have the material yet.

const hasText = (value) => typeof value === "string" && value.trim().length > 0;

const getSelectedClient = ({ values, selectedTiffIndex }) => values?.clients?.[selectedTiffIndex];

export const hasCaseBasics = ({ values }) =>
   hasText(values?.caseInfo?.caseName) && hasText(values?.caseInfo?.dateOfIncident);

export const hasNamedPlaintiff = ({ values }) =>
   Boolean(values?.clients?.some((client) => hasText(client?.personalInfo?.clientName)));

export const hasNamedDefendant = ({ values }) =>
   Boolean(values?.defendants?.some((defendant) => hasText(defendant?.personalInfo?.name)));

export const hasLiabilityNarrative = ({ values }) =>
   Boolean(values?.liability?.howincidentOccured?.some((entry) => hasText(entry?.text)));

export const hasPostAccidentProvider = (context) =>
   Boolean(getSelectedClient(context)?.medicalProviders?.postAccident?.medicalRecords?.length);

export const hasPainDetail = (context) => {
   const painAndSuffering = getSelectedClient(context)?.painAndSuffering;

   return (
      Boolean(painAndSuffering?.selectedPainPoints?.length) ||
      hasText(painAndSuffering?.descriptionText)
   );
};

// Re-exported so this stays the one module the edit case tour's stops import
// from; easy mode needs the same evaluator over a different context
export { evaluateRequirement } from "./tourRequirement";
